export const mockData = {
    link: "./mock-data/dynamic-href/link.json",
    empty: "./mock-data/dynamic-href/empty.json",
};
